





























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Picker, Popup } from 'vant';
Vue.use(Picker).use(Popup);
@Component
export default class PickerInput extends Vue {
  @Prop() title!: string;
  @Prop() PickerData!: object;
  @Prop() PickeWorkTypeData!: object;
  @Prop({ default: '请选择' }) placeholder!: string;
  value: string = '';
  workTypevalue: string = '';
  showPicker: boolean = false;
  @Watch('workTypevalue')
  onPickerDataChanged(newVal: any, val: any) {
    if (newVal && val) {
      console.log('workType重新选择', newVal, val);
      setTimeout(() => {
        this.$router.go(0);
      }, 100);
    }
  }
  startPicker() {
    this.showPicker = true;
  }
  onConfirm(e: string, index: number) {
    this.$emit('selectData', e, index);
    this.value = e;
    this.showPicker = false;
  }
  onConfirmWorkType(e: string, index: number) {
    this.$emit('selectWorkTypeData', e, index);
    this.workTypevalue = e;
    this.showPicker = false;
  }
}
